import { render, staticRenderFns } from "./formal_accounts.vue?vue&type=template&id=9b3c3df6&"
import script from "./formal_accounts.vue?vue&type=script&lang=js&"
export * from "./formal_accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports